<template>
    <div v-if="loggedIn" class="cursor-pointer relative z-50">
        <span
            class="absolute right-0 transition opacity-0 group-hover:opacity-100 group-hover:transform-none transform-right toggle-favorite"
        >
            <div class="relative w-6 h-6 z-40">
                <transition-group
                    leave-active-class="animated zoomOut"
                    enter-active-class="animated fadeIn"
                    mode="out-in"
                >
                    <div
                        v-if="isFavorited(store)"
                        @click="removeFavorite(store)"
                        class="w-6 h-6 absolute"
                        key="1"
                    >
                        <svg-icon
                            url="fas/heart"
                            cursor="pointer"
                            class="text-red-500"
                        />
                        <svg-icon
                            url="fas/bolt"
                            class="w-3 h-3 absolute mx-auto inset-0 text-white"
                            cursor="pointer"
                            style="left:1px; top: -1px;"
                        />
                    </div>
                    <div
                        v-else
                        @click="addFavorite(store)"
                        class="w-6 h-6 absolute"
                        key="2"
                    >
                        <svg-icon
                            url="fas/heart"
                            cursor="pointer"
                            class="text-red-500"
                        />
                    </div>
                </transition-group>

            </div>
        </span>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: {
            store: {
                required: true,
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'isFavorited', 'loggedIn']),
        },

        methods: {
            ...mapActions('general', [
                'addFavorite',
                'removeFavorite',
            ]),
        },
    }
</script>
